// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__28vGu","container":"About_container__1NKkt","title":"About_title__3fLlf","more":"About_more__3Nan7"};